import { useEffect } from 'react';
import { notifyFiltersClosed } from '../../channels/monitorChannel';

export function useFiltersChannel() {

    useEffect(() => {

        const handleUnload = () => {

            notifyFiltersClosed();

        };

        window.addEventListener(
            'beforeunload',
            handleUnload
        );

        return () => {

            window.removeEventListener(
            'beforeunload',
            handleUnload
            );

        };

    }, []);

}